import { render, staticRenderFns } from "./JuegoBanner.vue?vue&type=template&id=740a0dda&scoped=true"
import script from "./JuegoBanner.vue?vue&type=script&lang=js"
export * from "./JuegoBanner.vue?vue&type=script&lang=js"
import style0 from "./JuegoBanner.vue?vue&type=style&index=0&id=740a0dda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740a0dda",
  null
  
)

export default component.exports